/**
 * 定时任务调度
 * 
 * @author whiteshader@163.com
 * @date 2023-02-07
 */

export default {
	'monitor.job.title': '定时任务调度',
	'monitor.job.job_id': '任务编号',
	'monitor.job.job_name': '任务名称',
	'monitor.job.job_group': '任务组名',
	'monitor.job.invoke_target': '调用方法',
	'monitor.job.cron_expression': 'cron执行表达式',
	'monitor.job.misfire_policy': '执行策略',
	'monitor.job.concurrent': '是否并发执行',
	'monitor.job.next_valid_time': '下次执行时间',
	'monitor.job.status': '状态',
	'monitor.job.create_by': '创建者',
	'monitor.job.create_time': '创建时间',
	'monitor.job.update_by': '更新者',
	'monitor.job.update_time': '更新时间',
	'monitor.job.remark': '备注信息',
	'monitor.job.detail': '任务详情',
};
